<template>
  <div>
    <headerBreadCrumbs :breadCrumbs="breadCrumbs" title="Add Mass Notification" />

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left mb-4">
          <form class="card-body" @submit.prevent="handleSubmit">

            <div class="row px-3">
              <InputLabel v-model="data.title" label="Title" placeholder="" type="text" class="col-5" :required="true"
                :notes="'Title of Promo as reference'" />
              <InputLabel v-if="selectedAwardType != 3" v-model="data.notes" label="Note to User" placeholder=""
                type="text" class="col-7" :required="selectedAwardType != 3"
                :notes="'It will be displayed on the Product Quotation page'" />
            </div>

            <div class="row px-3 mt-4">
              <div class="form-group col-5">
                <label>Award Points</label>
                <div class="row">
                  <div v-for="(award, index) in award_types" :key="index">
                    <label class="radio radio-gold ml-3">
                      <input @click="changeSelectedAward(award.value)" type="radio" name="activeStatus"
                        v-model="data.type" v-bind:value="award.value">

                      <div class="d-flex flex-row child-flex-class">
                        <span>{{ award.name }}</span>
                      </div>
                      <span class="checkmark"></span>
                    </label>

                  </div>
                </div>

                <div v-if="selectedAwardType != 3" class="mt-3 d-flex flex-row flex-gap-4">
                  <label v-if="selectedAwardType == 2" class="align-self-center mr-4 pb-2">X</label>
                  <InputLabel v-model="data.award_points" placeholder="" type="number"
                    :required="selectedAwardType != 3" min="1" />
                </div>

                <div class="row mt-3" v-if="selectedAwardType == 3">
                  <div v-for="(none_type, index) in none_types" :key="none_type.value">
                    <label v-if="none_type.value == 1" class="radio radio-gold ml-3">
                      <input @click="changeSelectedNonType(none_type.value)" type="radio" name="nonTypeStatus"
                        v-model="data.none_type" v-bind:value="none_type.value">

                      <div class="d-flex flex-row child-flex-class">
                        <span>{{ none_type.name }}</span>
                      </div>
                      <span class="checkmark"></span>
                    </label>

                    <div v-else class="d-flex flex-row">
                      <label class="radio radio-gold ml-3">
                        <input @click="changeSelectedNonType(none_type.value)" type="radio" name="nonTypeStatus"
                          v-model="data.none_type" v-bind:value="none_type.value">
                        <span class="checkmark"></span>
                      </label>
                      <div class="row">
                        <span class="col-4">Inactive Since </span>
                        <div class="col-5">
                          <InputLabel :disabled="selectedNonType == 1 || data.meta.selection_method == 'excel'"
                            v-model="data.days" placeholder="" type="number" class="" :required="true" min="1" />
                        </div>
                        <span class="col-3">days ago</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-7">

                <InputLabel v-model="data.description" label="Description" type="textarea" :required="true"
                  :notes="'This will be sent as SMS to Non-Registered TBM Users'" :requireSmsText="true" />
              </div>

            </div>

            <div class="row px-3 mt-3">
              <div class="col-4">
                <InputLabel v-model="data.start_date" label="Start Date" type="date" required />
              </div>

              <div class="col-4">
                <InputLabel v-model="data.end_date" label="End Date" type="date" required />
              </div>
            </div>

            <div class="row px-3 mt-3">
              <div class="col-4">
                <InputLabel v-model="data.time" label="Time" type="time" required />
              </div>

              <div class="col-4 pt-4" style="align-self: center;">
                <input class="mr-2" type="checkbox" id="send_sms" v-model="data.send_sms" :value="true"
                  :disabled="disabledSms">
                <label class="mr-4" :for="`send_sms`">Send SMS to non-existing users</label>
              </div>
            </div>

            <div class="row px-3 mt-3" v-if="selectedAwardType != 3">
              <div v-for="(condition, index) in condition_types" :key="condition.value">
                <label class="radio radio-gold ml-3">
                  <input @click="changeSelectedCondition(condition.value)" type="radio" name="activeCondition"
                    v-model="data.meta.selection_method" v-bind:value="condition.value">

                  <div class="d-flex flex-row child-flex-class">
                    <span>{{ condition.name }}</span>
                  </div>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>

            <div class="row px-3 mt-3" v-if="selectedAwardType == 3">
              <div>
                <label class="radio radio-gold ml-3">
                  <input type="radio" name="activeCondition" value="excel" v-model="data.meta.selection_method"
                    @click="changeSelectedCondition('excel')">
                  <div class="d-flex flex-row child-flex-class">
                    <span>Use Excel</span>
                  </div>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>

            <div v-if="selectedConditionType == 'conditions'">
              <div class="px-3 mt-3" v-for="(condition, index) in data.meta.conditions" :key="index">
                <div class="row">
                  <div class="col-3 mr-2">
                    <SelectionComponent :label="`Condition ${index + 1} ${index == 0 ? '(Required)' : '(Optional)'}`"
                      :options="conditions" v-model="condition.type" :placeholder="'Please Select'"
                      :currentlySelected="checkSelected(index)" />
                  </div>

                  <div class="col-2" v-if="condition.type == 'gender'">
                    <SelectionComponent :label="'Gender'" :options="genders" v-model="condition.value" />
                  </div>
                  <div class="col-4" v-else-if="condition.type == 'age_range'">
                    <RangeComponent :ageFrom.sync="condition.age_from" :ageTo.sync="condition.age_to" from-label="From"
                      to-label="To" unit-label="Years Old" :requiredInput="condition.type == 'age_range'" />
                  </div>
                  <div class="col-5 pt-4" v-else-if="condition.type == 'tier'">
                    <TierComponent v-for="(condition, childIndex) in tier_conditions" :key="condition.value"
                      :condition="condition" :index="childIndex" :data.sync="data" :checkboxTiers="checkboxTiers"
                      :childIndexing="index" />
                  </div>
                </div>
              </div>
            </div>

            <div v-show="selectedAwardType != 3 && (showExcelUploader || showProductSelector)"
              class="form-group px-3 mt-3">
              <label>Select Product: </label>

              <div class="row">
                <div v-for="(value, key) in products" :key="key" class="col-6">

                  <div class="row px-3">
                    <span class="mr-3 font-bold" style="text-transform: uppercase;">{{ key }}</span>
                    <div class="row">
                      <span v-for="(product, productIndex) in value" class="col-6" :key="productIndex">
                        <input class="mr-2" type="checkbox" :id="`product_${product.id}`" v-model="data.products"
                          :value="product.id">
                        <label class="mr-4 text-small" :for="`product_${product.id}`">{{ product.name }}</label>
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <button class="float-right btn btn-primary mr-4" type="submit" :disabled="isLoading">Submit</button>

            <div v-if="showExcelUploader">
              <excel-uploader :tableData="tableData" @update:tableData="updateTableData" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import headerBreadCrumbs from '../../../components/headerBreadCrumbs.vue';
import InputLabel from '../../../components/UI/InputLabel.vue';
import { storeMassNotification } from '../../../services/MassNotificationService';
import { getProducts } from '../../../services/ProductService';
import ExcelUploader from './excel-upload-component.vue';

import SelectionComponent from '../../../components/UI/SelectionComponent.vue';
import RangeComponent from '../../../components/UI/RangeComponent.vue';
import RequirementInputLabel from '../../../components/UI/RequirementInputLabel.vue';
import CheckboxComponent from '../../../components/UI/CheckboxComponent.vue';
import TierComponent from '../../../components/UI/TierComponent.vue';

export default {
  components: {
    headerBreadCrumbs,
    InputLabel,
    ExcelUploader,
    SelectionComponent,
    RangeComponent,
    RequirementInputLabel,
    CheckboxComponent,
    TierComponent
  },

  data() {
    return {
      isLoading: false,

      breadCrumbs: [
        { name: 'Marketing', path: null },
        { name: 'Mass Notification', path: '/marketing/mass-notification' },
        { name: 'Add New', path: null },
      ],

      data: {
        title: '',
        description: '',
        notes: '',
        type: "1",
        none_type: '',
        days: '',
        award_points: null,
        start_date: '',
        end_date: '',
        time: '',
        send_sms: false,
        meta: {
          selection_method: "",
          conditions: [
            { priority: 1, type: "gender", value: "all", age_from: "", age_to: "", tier_from: "", tier_to: "", days: "", tiers: [] },
            { priority: 2, type: "", value: "male", age_from: "", age_to: "", tier_from: "", tier_to: "", days: "", tiers: [] },
          ],
        },
        products: []
      },

      award_types: [
        { value: 1, name: "Fixed" },
        { value: 2, name: "Rate" },
        { value: 3, name: "None" }
      ],

      condition_types: [
        { value: "excel", name: "Use Excel" },
        { value: "conditions", name: "Use Condition" }
      ],

      none_types: [
        { value: 1, name: "All" },
        { value: 2, name: "" },
      ],

      genders: [
        { value: "all", name: "All" },
        { value: "male", name: "Male" },
        { value: "female", name: "Female" },
      ],

      conditions: [
        { value: "gender", name: "Gender" },
        { value: "age_range", name: "Age" },
        { value: "tier", name: "Tier" },
      ],

      tier_conditions: [
        { value: "select_tier", name: "Select Tier" },
        { value: "point_range", name: "Tier Point Range" },
        { value: "expiry_in", name: "Expiry In" },
      ],

      checkboxTiers: [
        { value: 1, name: 'Silver' },
        { value: 2, name: 'Gold' },
        { value: 3, name: 'Platinum' },
        { value: 4, name: 'Black' },
      ],

      selectedAwardType: 1,
      selectedConditionType: "excel",
      selectedNonType: null,
      products: {},

      tableData: [],
      disabledSms: false,

      isUpdating: false,
    }
  },

  computed: {
    showExcelUploader() {
      return this.data.meta.selection_method === 'excel';
    },

    showProductSelector() {
      return this.selectedAwardType === 1 || this.selectedAwardType === 2;
    }
  },

  watch: {
    selectedNonType: function (newVal, oldVal) {
      if (this.selectedNonType == 1) {
        this.data.days = null;
      }

      // Clear excel selection when none_type is selected for award type 3
      if (this.selectedAwardType === 3 && newVal) {
        this.selectedConditionType = "";
        this.data.meta.selection_method = "";
      }
    },
    selectedAwardType: function (newVal, oldVal) {
      if (newVal === 3) {
        this.selectedConditionType = "";
        this.data.meta.selection_method = "";
        this.data.none_type = null;
        this.selectedNonType = null;
      } else {
        this.data.none_type = null;
        this.selectedNonType = null;
        this.data.days = null;
      }

      this.$nextTick(() => {
        this.disableSmsCheck();
      });
    },
    selectedConditionType: function (newVal, oldVal) {
      this.disableSmsCheck();
    },
  },


  'data.meta.conditions.0': {
    handler(newCondition) {
      if (this.isUpdating) return;

      this.isUpdating = true;
      if (newCondition.type === "tier") {
        if (newCondition.value === "select_tier") {
          this.resetValue(0, 'tier_from');
          this.resetValue(0, 'tier_to');
          this.resetValue(0, 'days');
        }

        if (newCondition.value === "point_range") {
          this.resetValue(0, 'tiers');
          this.resetValue(0, 'days');
        }

        if (newCondition.value === "expiry_in") {
          this.resetValue(0, 'tiers');
          this.resetValue(0, 'tier_from');
          this.resetValue(0, 'tier_to');
        }
      }
      this.$nextTick(() => {
        this.isUpdating = false;
      });
    },
    deep: true
  },

  'data.meta.conditions.1': {
    handler(newCondition) {
      if (this.isUpdating) return;

      this.isUpdating = true;
      if (newCondition.type === "tier") {
        if (newCondition.value === "select_tier") {
          this.resetValue(1, 'tier_from');
          this.resetValue(1, 'tier_to');
          this.resetValue(1, 'days');
        }

        if (newCondition.value === "point_range") {
          this.resetValue(1, 'tiers');
          this.resetValue(1, 'days');
        }

        if (newCondition.value === "expiry_in") {
          this.resetValue(1, 'tiers');
          this.resetValue(1, 'tier_from');
          this.resetValue(1, 'tier_to');
        }
      }
      this.$nextTick(() => {
        this.isUpdating = false;
      });
    },
    deep: true
  },

  methods: {
    changeSelectedAward(award) {
      this.selectedAwardType = award;

      if (award !== 3) {
        this.data.none_type = null;
        this.selectedNonType = null;
        this.data.days = null;
      }
    },

    changeSelectedCondition(condition) {
      if (this.selectedConditionType === condition) {
        this.selectedConditionType = "";
        this.data.meta.selection_method = "";
        // Clear none_type when deselecting excel for award type 3
        if (this.selectedAwardType === 3 && condition === "excel") {
          this.data.none_type = null;
          this.selectedNonType = null;
        }
      } else {
        this.selectedConditionType = condition;
        this.data.meta.selection_method = condition;
        // Set none_type to 3 when selecting excel for award type 3
        if (this.selectedAwardType === 3 && condition === "excel") {
          this.data.none_type = 3;
          this.selectedNonType = null;
          this.data.days = null;
        }
      }
      if (this.selectedAwardType === 3 && condition === "excel") {
        this.data.none_type = 3
        this.selectedNonType = null;
      }
    },

    changeSelectedNonType(none_type) {
      this.selectedNonType = none_type;

      // Clear excel selection when selecting none_type for award type 3
      if (this.selectedAwardType === 3 && none_type) {
        this.selectedConditionType = "";
        this.data.meta.selection_method = "";
      }
    },

    async fetchProducts() {
      try {
        const response = await getProducts();

        if (response.data.success) {
          this.products = response.data.data;
        }
      } catch (e) {
        console.error(e)
      }
    },

    async handleSubmit() {

      this.isLoading = true;
      try {
        if (!this.checkCheckboxSelected()) throw new Error("Please select tier(s)");
        if (!this.checkProducts()) throw new Error("Please select product(s)");
        if (!this.checkSmsField()) throw new Error("Please upload file");
        if (!this.fillUsers()) throw new Error("Please upload file");

        let confirmation = await swal({
          icon: "warning",
          text: `Please make sure everything is correct before submitting`,
          buttons: ["Cancel", "Yes"]
        });

        if (!confirmation) {
          this.isLoading = false;
          return;
        }

        console.log("data", this.data);

        const response = await storeMassNotification(this.data);

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });

        if (response.data.success) {
          this.$router.push('/marketing/mass-notification');
        }

      } catch (e) {
        const errorMessage = e.message || "An unexpected error occurred.";
        swal({
          icon: 'error',
          text: errorMessage
        });

        console.error(e)
      }

      this.isLoading = false;
    },

    resetData(obj, property) {
      obj[property] = []
    },

    checkProducts() {
      const required_type = [2, 1];
      if (required_type.includes(this.data.type) && this.data.products.length < 1) {
        return false;
      }
      return true;
    },

    updateTableData(newData) {
      this.tableData = newData;
    },

    checkSmsField() {
      if (this.data.send_sms && this.tableData.length < 1) {
        return false;
      }
      return true;
    },

    fillUsers() {
      if (this.data.meta.selection_method === "excel") {
        if ((this.selectedAwardType === 1 || this.selectedAwardType === 2 || this.selectedAwardType === 3)) {
          if (this.tableData.length > 0) {
            this.data.users = this.tableData;
          } else {
            return false;
          }
        } else {
          this.data.users = [];
        }
      }

      return true;
    },

    resetValue(index, type) {
      if (type == "tiers") {
        this.data.meta.conditions[index][type] = []
      } else {
        this.data.meta.conditions[index][type] = ""
      }
    },

    updateTiers(newTiers, index) {
      this.data.meta.conditions[index].tiers = newTiers;
    },

    disableSmsCheck() {
      if (this.selectedAwardType == 1 && this.selectedConditionType == 'excel') {
        this.disabledSms = false;
      } else if (this.selectedAwardType == 2 && this.selectedConditionType == 'excel') {
        this.disabledSms = false;
      } else if ((this.selectedAwardType == 1 || this.selectedAwardType == 2) && this.selectedConditionType == 'conditions') {
        this.disabledSms = true;
      }
      else {
        this.data.send_sms = false;
        this.disabledSms = false;
      }
    },

    checkCheckboxSelected() {
      if (this.data.meta.conditions[0].type == 'tier' && this.data.meta.conditions[0].value == 'select_tier' && this.data.meta.conditions[0].tiers.length < 1) {
        return false;
      }

      if (this.data.meta.conditions[1].type == 'tier' && this.data.meta.conditions[1].value == 'select_tier' && this.data.meta.conditions[1].tiers.length < 1) {
        return false;
      }
      return true;
    },

    checkSelected(index) {
      return index == 0
        ? this.data.meta.conditions[1].type
        : this.data.meta.conditions[0].type
    }
  },

  async mounted() {
    await this.fetchProducts();
  }
}

</script>

<style scoped>
.tier_condition {
  gap: 10px !important;
}
</style>
